/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-return-assign */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable camelcase */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ReactToPrint from "react-to-print";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import { Tabs, Input, Icon, TimePicker, DatePicker } from "antd";
import { Row, Button, DropdownToggle, DropdownItem, DropdownMenu, Card, Label, CardBody, Dropdown, Form, FormGroup } from "reactstrap";
import Select from "react-select";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import { getRequestListDelta, addCommentItem, addRequestItem, requestGetItem, setIsTranslationNeeded } from "../../redux/request/actions";
import { createBookingItem } from "../../redux/booking/actions";
import defaultValues from "../../constants/defaultValues";
import MessageCard from "../../components/requests/MessageCard";
import SaySomething from "../../components/requests/SaySomething";
import FastCheckinPrint from "../../components/fastCheckin/FastCheckinPrint";
import CustomSelectInput from "../../components/common/CustomSelectInput";

const { TabPane } = Tabs;
class FastCheckinDetailsContainer extends Component {
  statsRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
      dropdownBasicOpen: false,
      messageInput: "",
      thirtySecondsPassedAfterDidMount: false,
      prevScrollpos: window.pageYOffset,
      rooms: null,
      keys: 0,
      phoneNumberError: [],
      emailError: []
    };
  }

  componentDidMount() {
    this.props.setIsTranslationNeeded(false);
    this.connectionTimer = setTimeout(() => {
      this.setState({ thirtySecondsPassedAfterDidMount: true });
    }, 30000);

    // window.scrollTo(0, document.body.scrollHeight);
    // window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.requestApp.error !== prevProps.requestApp.error && this.props.requestApp.showToast !== prevProps.requestApp.showToast) {
      const request = this.props.requestApp.allRequestItems[this.props.match.params.id];
      this.props.requestGetItem({
        request_id: request.id,
        isTranslationNeeded: this.props.requestApp.isTranslationNeeded
      });
    }
    if (
      this.props.requestApp.allRequestItems &&
      this.props.match.params.id &&
      this.props.requestApp.allRequestItems[this.props.match.params.id] &&
      this.props.requestApp.allRequestItems[this.props.match.params.id].comments
    ) {
      if (
        prevProps.requestApp.isTranslationNeeded !== this.props.requestApp.isTranslationNeeded ||
        prevProps.requestApp.loading !== this.props.requestApp.loading ||
        (prevProps.requestApp.allRequestItems &&
          prevProps.requestApp.allRequestItems[this.props.match.params.id] &&
          prevProps.requestApp.allRequestItems[this.props.match.params.id].comments &&
          this.props.requestApp.allRequestItems[this.props.match.params.id].comments.length !==
          prevProps.requestApp.allRequestItems[this.props.match.params.id].comments.length)
      ) {
        window.scrollTo(0, document.body.scrollHeight);
      }
    }
  }

  componentWillUnmount() {
    // window.removeEventListener("scroll", this.handleScroll);
    clearInterval(this.connectionTimer);
  }

  toggleBasic = () => {
    this.setState(prevState => ({
      dropdownBasicOpen: !prevState.dropdownBasicOpen
    }));
  };

  handleChatInputChange = e => {
    this.setState({
      messageInput: e.target.value
    });
  };

  handleSendButtonClick = () => {
    const request = this.props.requestApp.allRequestItems[this.props.match.params.id];
    if (this.state.messageInput.length > 0) {
      this.props.addCommentItem({
        request_id: request.id,
        author_id: this.props.staffId,
        body: this.state.messageInput
      });
      this.setState({
        messageInput: ""
      });
      this.props.setIsTranslationNeeded(false);
    }
  };

  handleCommentsTranslation = () => {
    const request = this.props.requestApp.allRequestItems[this.props.match.params.id];
    if (request.comments && request.comments.length) {
      if (!this.props.requestApp.isTranslationNeeded) {
        this.props.requestGetItem({
          request_id: request.id,
          isTranslationNeeded: !this.props.requestApp.isTranslationNeeded
        });
      }
      this.props.setIsTranslationNeeded(!this.props.requestApp.isTranslationNeeded);
    }
  };

  handleRequestStatus = status => {
    const request = this.props.requestApp.allRequestItems[this.props.match.params.id];
    this.props.addRequestItem({
      id: request.id,
      status
    });
  };

  toggleSplit = () => {
    this.setState(prevState => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen
    }));
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleScroll = event => {
    const currentScrollPos = window.pageYOffset;

    this.setState({
      prevScrollpos: currentScrollPos
    });
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  /** Booking detail container */

  handleChangeRooms = e => {
    this.setState({
      rooms: [e.target.value]
    });
  };

  createBookingItem = () => {
    const { custom_fields_values, requester_id } = this.props.requestApp.allRequestItems[this.props.match.params.id];
    const idIndex = custom_fields_values.findIndex(item => item.id === "311");
    const values = JSON.parse(custom_fields_values[idIndex].value);
    const rooms = {
      id: "313",
      value: JSON.stringify({
        rooms: this.state.rooms
      })
    };
    custom_fields_values.splice(0, 0, rooms);

    const toCreate = {
      checkin: values.checkin,
      checkout: values.checkout,
      hotel_id: String(this.props.settings.hotelConfig.hotelId),
      user_id: requester_id,
      status: "hotel_guest",
      birthday: values.birth_date,
      rooms: this.state.rooms,
      all_number: values.all_number,
      note: values.note
    };
    if (values.passport_number) {
      toCreate["passport_number"] = values.passport_number;
    }
    if (values.national_identification_number) {
      toCreate["national_identification_number"] = values.national_identification_number;
      toCreate["nationality"] = "TC";
    }
    if (values.nationality) {
      toCreate.nationality = values.nationality.toUpperCase();
    }
    try {
      this.props.createBookingItem(toCreate);
      const request = custom_fields_values;
      this.props.addRequestItem({
        id: request.id,
        status: "CLOSED",
        custom_fields_values
      });
    } catch (err) {
      console.error("Error in createBookingItem", err);
    }
  };

  onBirthdateChange = (birthdate, CustomFieldId, itemsById, index) => {
    const { custom_fields_values } = this.props.requestApp.allRequestItems[this.props.match.params.id];
    itemsById.birth_date = `${birthdate.unix()}`;
    const custom_field_value_by_id = itemsById;
    const idIndex = custom_fields_values.findIndex(item => item.id === CustomFieldId);
    let newValue;
    if (idIndex !== -1) {
      if (index > 0) {
        index -= 1;
        const value = JSON.parse(custom_fields_values[idIndex].value);
        value.splice(index, 1, custom_field_value_by_id);
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(value)
        };
      } else {
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(custom_field_value_by_id)
        };
      }
      custom_fields_values.splice(idIndex, 1, newValue);
    }
    try {
      this.props.addRequestItem({
        id: this.props.match.params.id,
        custom_fields_values
      });
    } catch (err) {
      console.error("Error in onDatesChange", err);
    }
  };

  assignRoomNumber = (CustomFieldId, itemsById, index) => {
    const { custom_fields_values } = this.props.requestApp.allRequestItems[this.props.match.params.id];
    const rooms = {
      id: "313",
      value: JSON.stringify({
        rooms: this.state.rooms
      })
    };

    custom_fields_values.splice(0, 0, rooms);

    const custom_field_value_by_id = itemsById;
    const idIndex = custom_fields_values.findIndex(item => item.id === CustomFieldId);
    let newValue;
    if (idIndex !== -1) {
      if (index > 0) {
        index -= 1;
        const value = JSON.parse(custom_fields_values[idIndex].value);
        value.splice(index, 1, custom_field_value_by_id);
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(value)
        };
      } else {
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(custom_field_value_by_id)
        };
      }
      custom_fields_values.splice(idIndex, 1, newValue);
    }
    try {
      this.props.addRequestItem({
        id: this.props.match.params.id,
        custom_fields_values
      });

      //TO-DO mesaj gonderme eklentisi buradan cikarilmali, ayri fonksiyon olarak eklenmeli ve gonderilen mesaj multi language olacak sekilde dinamiklesitirilmeli
      if (this.state.rooms != "") {
        const request = this.props.requestApp.allRequestItems[this.props.match.params.id];
        this.props.addCommentItem({
          request_id: request.id,
          author_id: this.props.staffId,
          body: `Dear ${request.fullName}, ${this.state.rooms} is assigned as your room number!`
        });
      }
      this.setState({
        messageInput: ""
      });
      this.props.setIsTranslationNeeded(false);
    } catch (err) {
      console.error("Error in assignRoomNumber", err);
    }
  };

  onDatesChange = (startDate, endDate) => {
    const { custom_fields_values } = this.props.requestApp.allRequestItems[this.props.match.params.id];
    const idIndex = custom_fields_values.findIndex(item => item.id === "311");

    const values = JSON.parse(custom_fields_values[idIndex].value);
    values.checkin = `${startDate.unix()}`;
    if (endDate) {
      values.checkout = `${endDate.unix()}`;
    }

    const newValue = {
      id: "311",
      value: JSON.stringify(values)
    };
    custom_fields_values.splice(idIndex, 1, newValue);

    try {
      this.props.addRequestItem({
        id: this.props.match.params.id,
        custom_fields_values
      });
    } catch (err) {
      console.error("Error in onDatesChange", err);
    }
  };

  handleCheckinHour = (time, checkin) => {
    const checkinTimeStamp = moment(checkin * 1000);
    const checkinSethours = checkinTimeStamp.set({ hour: `${time.format("HH")}` });
    const { custom_fields_values } = this.props.requestApp.allRequestItems[this.props.match.params.id];
    const idIndex = custom_fields_values.findIndex(item => item.id === "311");
    const values = JSON.parse(custom_fields_values[idIndex].value);
    values.time_of_arrival = `${checkinSethours.unix()}`;
    const newValue = {
      id: "311",
      value: JSON.stringify(values)
    };
    custom_fields_values.splice(idIndex, 1, newValue);
    try {
      this.props.addRequestItem({
        id: this.props.match.params.id,
        custom_fields_values
      });
    } catch (err) {
      console.error("Error in onDatesChange", err);
    }
  };

  attachment = passport => {
    const fileName = passport.split("/").pop();
    const extension = fileName.split(".").pop();
    if (extension === "png" || extension === "jpeg" || extension === "jpg") {
      return <img src={passport} alt="passport attachment" className="preview-container" />;
    }
    return (
      <>
        <i className="simple-icon-paper-clip" /> <i>{fileName}</i>
      </>
    );
  };

  validate = (e, index) => {
    if (e.target.name === "phone_number") {
      const phoneNumberError = !e.target.value.match(/^\+[0-9]{10,15}$/m);
      const findIndexPhoneNumberError = this.state.phoneNumberError.findIndex(item => item.id === index);
      if (phoneNumberError === true && findIndexPhoneNumberError === -1) {
        this.setState({
          phoneNumberError: [...this.state.phoneNumberError, { id: index, phoneNumberError }]
        });
      }
      if (phoneNumberError === false && findIndexPhoneNumberError !== -1) {
        const newState = this.state.phoneNumberError.filter((_, i) => i !== findIndexPhoneNumberError);
        this.setState({
          phoneNumberError: newState
        });
      }
    }

    if (e.target.name === "email") {
      const emailError = !e.target.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/m);
      const findIndexEmailError = this.state.emailError.findIndex(item => item.id === index);
      if (emailError === true && findIndexEmailError === -1) {
        this.setState({
          emailError: [...this.state.emailError, { id: index, emailError }]
        });
      }
      if (emailError == false && findIndexEmailError !== -1) {
        const newState = this.state.emailError.filter((_, i) => i !== findIndexEmailError);
        this.setState({
          emailError: newState
        });
      }
    }
  };

  handleCheckBox = (e, CustomFieldId, itemsById, index) => {
    const { custom_fields_values } = this.props.requestApp.allRequestItems[this.props.match.params.id];
    itemsById.has_traveled = e.target.checked;
    const custom_field_value_by_id = itemsById;
    const idIndex = custom_fields_values.findIndex(item => item.id === CustomFieldId);
    let newValue;
    if (idIndex !== -1) {
      if (index > 0) {
        index -= 1;
        const value = JSON.parse(custom_fields_values[idIndex].value);
        value.splice(index, 1, custom_field_value_by_id);
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(value)
        };
      } else {
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(custom_field_value_by_id)
        };
      }
      custom_fields_values.splice(idIndex, 1, newValue);
    }
    this.addRequest(custom_fields_values);
  };

  handleTextBox = (e, CustomFieldId, itemsById, index) => {
    const eventValue = e.target.value.trim();
    if (itemsById[e.target.name] == eventValue) {
      return;
    }
    if (e.target.name === "phone_number") {
      this.setState({
        phone_number: eventValue
      });
    }
    if (e.target.name === "email") {
      this.setState({
        email: eventValue
      });
    }
    const { custom_fields_values } = this.props.requestApp.allRequestItems[this.props.match.params.id];
    itemsById[e.target.name] = eventValue;
    const custom_field_value_by_id = itemsById;
    const idIndex = custom_fields_values.findIndex(item => item.id === CustomFieldId);
    let newValue;
    if (idIndex !== -1) {
      if (index > 0) {
        index -= 1;
        const value = JSON.parse(custom_fields_values[idIndex].value);
        value.splice(index, 1, custom_field_value_by_id);
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(value)
        };
      } else {
        newValue = {
          id: CustomFieldId,
          value: JSON.stringify(custom_field_value_by_id)
        };
      }
      custom_fields_values.splice(idIndex, 1, newValue);
    }
    this.addRequest(custom_fields_values);
  };

  addRequest = custom_fields_values => {
    if (this.state.phoneNumberError.length === 0 && this.state.emailError.length === 0) {
      try {
        this.props.addRequestItem({
          id: this.props.match.params.id,
          custom_fields_values
        });
      } catch (err) {
        console.error("err in addRequest", err);
      }
    }
  };

  callback = key => {
    this.setState({
      keys: key
    });
  };

  render() {
    const { addRequestLoading, addCommentLoading } = this.props.requestApp;
    const { addCreateLoading } = this.props.bookingApp;
    const { locale, hotelConfig } = this.props.settings;
    const items = this.props.requestApp.allRequestItems;
    let request;
    if (items && this.props.match.params.id) {
      request = items[this.props.match.params.id];
    }
    const { messageInput } = this.state;
    const { messages } = this.props.intl;
    const { countryList } = this.props.intl.messages;
    const formatTime = "HH:mm";
    const birthdateFormat = "DD/MM/YYYY";

    const nationalityValue = res => {
      let currentOption = 0;
      for (let i = 0; i < Object.keys(countryList).length; i += 1) {
        if (res.nationality === countryList[i].value) {
          currentOption = i;
        }
      }
      return countryList[currentOption];
    };

    if (request) {
      const otherRequestStatuses = Object.values(defaultValues.requestStatusEnum).filter(
        requestStatus => requestStatus !== defaultValues.requestStatusEnum[request.status] && requestStatus !== "request.status_pending"
      );

      const otherRequestStatusIntlKeys = Object.keys(defaultValues.requestStatusEnum).filter(
        requestStatus => requestStatus !== request.status && requestStatus !== "PENDING"
      );

      const otherRequestStatusesDropdownItems = otherRequestStatuses.map((reqStatus, index) => (
        <DropdownItem onClick={() => this.handleRequestStatus(otherRequestStatusIntlKeys[index])} key={`${reqStatus}`}>
          <IntlMessages id={`${reqStatus}`} />
        </DropdownItem>
      ));

      let commentMessageCards = [];
      let emptyStateMessageCard;
      if (request.comments && request.comments.length) {
        commentMessageCards = request.comments.map((item, index) => {
          return (
            <div key={index}>
              <MessageCard
                key={item.id}
                sender={{ name: item.author_name, thumb: "", text: item.body }}
                item={item}
                locale={locale}
                isTranslationNeeded={this.props.requestApp.isTranslationNeeded}
                currentUserid={request.requester_id}
                bucket={`https://${hotelConfig.bucket}.s3.eu-west-1.amazonaws.com/public/`}
                file={item.attachments}
              />
            </div>
          );
        });
      } else if (!request.comments && !addCommentLoading) {
        emptyStateMessageCard = (
          <div style={{ textAlign: "center" }}>
            <i className="iconsminds-inbox-empty text-muted" style={{ fontSize: "25px" }} />
            <Label className="list-item-heading mb-2 text-muted">
              <IntlMessages id="request.empty_message_box" />
            </Label>
            {/* <div className="separator mb-5" /> */}
          </div>
        );
      }
      if (addCommentLoading) {
        commentMessageCards.push(<MessageCard item={{ is_staff: "true" }} isLoading />);
      }

      let CustomFieldsValues;
      let CustomFieldsValuesRooms;
      let CustomFieldsValuesRoomsValue;
      if (request.custom_fields_values) {
        if (request.service_type === "FAST_CHECK_IN") {
          const { custom_fields_values } = request;
          if (custom_fields_values[0] && custom_fields_values[0].value && JSON.parse(custom_fields_values[0].value).rooms) {
            CustomFieldsValuesRoomsValue = JSON.parse(custom_fields_values[0].value).rooms[0];
            CustomFieldsValuesRooms = true;
          }
          const idIndex311 = custom_fields_values.findIndex(item => item.id === "311");
          let custom_fields_values_311;
          if (idIndex311 !== -1) {
            custom_fields_values_311 = JSON.parse(request.custom_fields_values[idIndex311].value);
            custom_fields_values_311.id = "311";
          }
          const idIndex312 = custom_fields_values.findIndex(item => item.id === "312");
          let custom_fields_values_312;
          if (idIndex312 !== -1) {
            custom_fields_values_312 = JSON.parse(request.custom_fields_values[idIndex312].value);
            custom_fields_values_312.forEach(res => (res.id = "312"));
            custom_fields_values_312.splice(0, 0, custom_fields_values_311);
            CustomFieldsValues = custom_fields_values_312;
          } else {
            CustomFieldsValues = [custom_fields_values_311];
          }
        }
      }

      return (
        <Fragment>
          {/* <div ref={this.statsRef}/> */}
          <Row className="survey-app">
            <Colxx xxs="12">
              <Fragment>
                <Row>
                  <Colxx xxs="12" lg="3" className="mb-4">
                    <Button onClick={this.goBack} type="button" className="btn outline-light flex-grow-1 " color="outline-info" size="sm">
                      <i className="iconsminds-arrow-left booking-heading-icon" />
                      <IntlMessages id="request.back_button" />
                    </Button>
                  </Colxx>
                  <Colxx xxs="12" lg="6" className="mb-4">
                    <h1 className="request-header text-center align-middle w-100">
                      <IntlMessages id="request.request_details" />
                    </h1>
                  </Colxx>
                  <Colxx xxs="12" lg="3" className="mb-4 top-right-button-container" style={{ textAlign: "right" }}>
                    <Dropdown isOpen={this.state.dropdownSplitOpen} toggle={this.toggleSplit} className="text-center w-100">
                      <DropdownToggle
                        caret
                        color={`${request.status === "CLOSED"
                          ? "light"
                          : request.status === "OPEN"
                            ? "primary"
                            : request.status === "CANCELED"
                              ? "light"
                              : "warning"
                          }`}
                      >
                        <IntlMessages id={`${defaultValues.requestStatusEnum[request.status]}`} />
                      </DropdownToggle>
                      <DropdownMenu>{otherRequestStatusesDropdownItems}</DropdownMenu>
                    </Dropdown>
                  </Colxx>
                </Row>
              </Fragment>
              <Fragment>
                <Row>
                  {!addRequestLoading && !addCommentLoading && !addCreateLoading ? (
                    <Colxx xxs="12" lg="3" className="mb-4">
                      <Card className="mb-4 text-center">
                        <CardBody>
                          {request.is_staff && request.is_staff === "true" ? (
                            <div className="badge badge-danger" style={{ fontSize: "15px" }}>
                              <IntlMessages id="alacarte.request_owner_staff" />
                            </div>
                          ) : (
                            <div>
                              <h3 className="list-item-heading mb-2">{request.fullName}</h3>
                              {request && request.phone_number ? (
                                <div className="text-center">
                                  <a href={`tel:${request.phone_number}`} style={{ paddingBottom: "2px", color: "green" }} className="tel">
                                    <i className="simple-icon-phone" />
                                    {request.phone_number}
                                  </a>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </CardBody>
                      </Card>
                      <Card className="mb-4 text-center">
                        <CardBody>
                          <div>
                            <h3 className="list-item-heading mb-1">
                              <IntlMessages id="booking.room_assignment" />
                            </h3>
                            <hr />
                            <div className="mb-2">
                              <Input
                                // key={res.e_mail}
                                type="text"
                                name="room"
                                defaultValue={CustomFieldsValuesRoomsValue}
                                // defaultValue={res.e_mail}
                                onChange={this.handleChangeRooms}
                                placeholder={messages["booking.room"]}
                                className="room-button w-60 w-xs-100"
                              />{" "}
                              <Button
                                type="button"
                                className="flex-grow-1 "
                                color="primary"
                                size="xs"
                                //disabled={CustomFieldsValuesRooms}
                                onClick={this.assignRoomNumber}
                              >
                                <IntlMessages id="booking.OK" />
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      <Card className="cart-for-dates mb-4">
                        <CardBody>
                          <div className="w-100 float-left mb-1">
                            <IntlMessages id="request.created_at" /> {request.created_at_date}
                          </div>
                          <div className="w-100 float-left mb-1">
                            {" "}
                            <IntlMessages id="request.last_update" /> {request.updated_at_date}
                          </div>
                          <div className="w-100 float-left mb-2">
                            <IntlMessages id="request.due_date" /> {request.due_at_date}
                          </div>
                        </CardBody>
                      </Card>
                    </Colxx>
                  ) : (
                    <Colxx xxs="12" lg="3" className="mb-4">
                      <Card className="mb-4 text-center">
                        <CardBody>
                          <div className="loading" style={{ position: "inherit" }} />
                        </CardBody>
                      </Card>
                    </Colxx>
                  )}
                  <Colxx xxs="12" lg="8">
                    {CustomFieldsValues && CustomFieldsValues.length > 0 ? (
                      <Card className="mb-4">
                        <Tabs type="card" size="large" onChange={e => this.callback(e)}>
                          {CustomFieldsValues.map((res, index) => {
                            return (
                              <TabPane
                                tab={
                                  this.state.keys === index ? (
                                    <div>
                                      {this.state.phoneNumberError.findIndex(item => item.id === index) !== -1 ||
                                        this.state.emailError.findIndex(item => item.id === index) !== -1 ? (
                                        <span style={{ color: "purple" }}>
                                          <Icon type="exclamation-circle" />
                                          <Icon type="user" />
                                          {res.name} {res.surname}
                                        </span>
                                      ) : (
                                        <span style={{ color: "purple" }}>
                                          <Icon type="user" />
                                          {res.name} {res.surname}
                                        </span>
                                      )}
                                    </div>
                                  ) : this.state.keys !== index ? (
                                    <div>
                                      {this.state.phoneNumberError.findIndex(item => item.id === index) !== -1 ||
                                        this.state.emailError.findIndex(item => item.id === index) !== -1 ? (
                                        <span style={{ color: "gray" }}>
                                          <Icon type="exclamation-circle" />
                                          <Icon type="user" />
                                          {res.name} {res.surname}
                                        </span>
                                      ) : (
                                        <span style={{ color: "gray" }}>
                                          <Icon type="user" />
                                          {res.name} {res.surname}
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )
                                }
                                key={index}
                              >
                                <span className="p-5"></span>
                                <div className="float-right mr-4 mb-3">
                                  <ReactToPrint
                                    trigger={() => (
                                      <Button type="button" outline color="primary" bodyClass={"print-page"}>
                                        <IntlMessages id="alacarte.print" /> <i class="simple-icon-printer"></i>
                                      </Button>
                                    )}
                                    content={() => this.componentRef}
                                    documentTitle={CustomFieldsValues[this.state.keys].name}
                                  />
                                </div>
                                <div className="card-body pt-0 mr-2 ml-2 mt-5">
                                  <div className="edit-mode">
                                    <div className="d-none">
                                      <FastCheckinPrint personelInfo={CustomFieldsValues[this.state.keys]} ref={el => (this.componentRef = el)} />
                                    </div>

                                    <Form>
                                      {res.national_identification_number != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="bookingDetails.national_identification_number" />
                                          </label>
                                          <Input
                                            key={res.national_identification_number}
                                            type="text"
                                            name="national_identification_number"
                                            defaultValue={res.national_identification_number}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["bookingDetails.national_identification_number"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.passport_number != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="bookingDetails.passport_number" />
                                          </label>
                                          <Input
                                            key={res.passport_number}
                                            type="text"
                                            name="passport_number"
                                            defaultValue={res.passport_number}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["bookingDetails.passport_number"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.father_name != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.father_name" />
                                          </label>

                                          <Input
                                            key={res.father_name}
                                            type="text"
                                            name="father_name"
                                            defaultValue={res.father_name}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.father_name"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.mother_name != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.mother_name" />
                                          </label>

                                          <Input
                                            key={res.mother_name}
                                            type="text"
                                            name="mother_name"
                                            defaultValue={res.mother_name}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.mother_name"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.nationality != null && (
                                        <FormGroup className="d-flex">
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="bookingDetails.nationality" />
                                          </label>
                                          <Select
                                            components={{ Input: CustomSelectInput }}
                                            classNamePrefix="react-select"
                                            className="react-select w-60 w-xs-100"
                                            name="nationality"
                                            value={nationalityValue(res)}
                                            onChange={e => {
                                              e.target = { name: "nationality", value: e.value };
                                              this.handleTextBox(e, res.id, res, index);
                                            }}
                                            options={countryList}
                                          />
                                        </FormGroup>
                                      )}
                                      {res.birth_date != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="bookingDetails.birth_date" />
                                          </label>
                                          <DatePicker
                                            defaultValue={moment(res.birth_date * 1000)}
                                            format={birthdateFormat}
                                            onChange={e => this.onBirthdateChange(e, res.id, res, index)}
                                          />
                                        </FormGroup>
                                      )}
                                      {res.birth_place != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.birth_place" />
                                          </label>

                                          <Input
                                            key={res.birth_place}
                                            type="text"
                                            name="birth_place"
                                            defaultValue={res.birth_place}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.birth_place"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.gender != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="bookingDetails.gender" />
                                          </label>

                                          <Input
                                            key={res.gender}
                                            type="text"
                                            name="gender"
                                            defaultValue={res.gender}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["bookingDetails.gender"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.document_type != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.document_type" />
                                          </label>

                                          <Input
                                            key={res.document_type}
                                            type="text"
                                            name="document_type"
                                            defaultValue={res.document_type}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.document_type"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.serial_number != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.serial_number" />
                                          </label>

                                          <Input
                                            key={res.serial_number}
                                            type="text"
                                            name="serial_number"
                                            defaultValue={res.serial_number}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.serial_number"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.date_of_issue != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.date_of_issue" />
                                          </label>
                                          <DatePicker
                                            defaultValue={moment(res.date_of_issue * 1000)}
                                            format={birthdateFormat}
                                            onChange={e => this.onBirthdateChange(e, res.id, res, index)}
                                          />
                                        </FormGroup>
                                      )}
                                      {res.date_of_expire != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.date_of_expire" />
                                          </label>
                                          <DatePicker
                                            defaultValue={moment(res.date_of_expire * 1000)}
                                            format={birthdateFormat}
                                            onChange={e => this.onBirthdateChange(e, res.id, res, index)}
                                          />
                                        </FormGroup>
                                      )}
                                      {res.city_of_registry != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.city_of_registry" />
                                          </label>

                                          <Input
                                            key={res.city_of_registry}
                                            type="text"
                                            name="city_of_registry"
                                            defaultValue={res.city_of_registry}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.city_of_registry"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.town_of_registry != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.town_of_registry" />
                                          </label>

                                          <Input
                                            key={res.town_of_registry}
                                            type="text"
                                            name="town_of_registry"
                                            defaultValue={res.town_of_registry}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.town_of_registry"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.address != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.address" />
                                          </label>

                                          <Input
                                            key={res.address}
                                            type="text"
                                            name="address"
                                            defaultValue={res.address}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.address"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.city != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.city" />
                                          </label>

                                          <Input
                                            key={res.city}
                                            type="text"
                                            name="city"
                                            defaultValue={res.city}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.city"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.country != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.country" />
                                          </label>

                                          <Input
                                            key={res.country}
                                            type="text"
                                            name="country"
                                            defaultValue={res.country}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.country"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.checkin && res.checkout && res.id === "311" ? (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="bookingDetails.checkin_checkout" />
                                          </label>

                                          <DateRangePicker
                                            isOutsideRange={() => false}
                                            small
                                            withPortal
                                            orientation={window.matchMedia("(max-width: 700px)").matches ? "vertical" : "horizontal"}
                                            showDefaultInputIcon
                                            startDate={moment(res.checkin * 1000)} // momentPropTypes.momentObj or null,
                                            startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                            endDate={moment(res.checkout * 1000)} // momentPropTypes.momentObj or null,
                                            endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                            onDatesChange={({ startDate, endDate }) => this.onDatesChange(startDate, endDate)} // PropTypes.func.isRequired,
                                            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      ) : (
                                        ""
                                      )}
                                      {res.time_of_arrival && res.id === "311" ? (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="booking.time_of_arrival_at_hotel" />
                                          </label>
                                          <TimePicker
                                            defaultValue={moment(
                                              `${moment(res.time_of_arrival * 1000)
                                                .toDate()
                                                .getHours()}:00`,
                                              formatTime
                                            )}
                                            format={formatTime}
                                            id="time_of_arrival"
                                            onChange={e => this.handleCheckinHour(e, res.time_of_arrival, res.id, res, index)}
                                            className="w-16"
                                          />
                                        </FormGroup>
                                      ) : (
                                        ""
                                      )}
                                      {res.car_plate != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.car_plate" />
                                          </label>

                                          <Input
                                            key={res.car_plate}
                                            type="text"
                                            name="car_plate"
                                            defaultValue={res.car_plate}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.car_plate"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.phone_number != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="booking.phone-placeholder" />
                                          </label>

                                          <label className="w-60 w-xs-100">
                                            <Input
                                              key={res.phone_number}
                                              type="text"
                                              name="phone_number"
                                              defaultValue={res.phone_number}
                                              onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                              onChange={e => this.validate(e, index)}
                                              placeholder={messages["booking.phone-placeholder"]}
                                              className="w-100 w-xs-100"
                                            />

                                            {this.state.phoneNumberError.findIndex(item => item.id === index) !== -1 ? (
                                              <span style={{ color: "red" }} className="w-100 w-xs-100">
                                                <IntlMessages id="form.valid.mobile" />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </label>
                                        </FormGroup>
                                      )}
                                      {res.email != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="user.email" />
                                          </label>
                                          <label className="w-60 w-xs-100">
                                            <Input
                                              key={res.email}
                                              type="text"
                                              name="email"
                                              defaultValue={res.email || ""}
                                              onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                              onChange={e => this.validate(e, index)}
                                              placeholder={messages["user.email"]}
                                              className="w-100 w-xs-100"
                                            />
                                            {this.state.emailError.findIndex(item => item.id === index) !== -1 ? (
                                              <span style={{ color: "red" }} className="w-100 w-xs-100">
                                                <IntlMessages id="form.valid.email" />
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </label>
                                        </FormGroup>
                                      )}

                                      {res.has_pet != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.has_pet" />
                                          </label>

                                          <Input
                                            key={res.has_pet}
                                            type="text"
                                            name="has_pet"
                                            defaultValue={res.has_pet}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.has_pet"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}

                                      {res.note != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="user.note" />
                                          </label>
                                          <Input
                                            key={res.note}
                                            type="text"
                                            name="note"
                                            defaultValue={res.note || ""}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["user.note"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.all_number != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="user.all_number" />
                                          </label>
                                          <Input
                                            key={res.all_number}
                                            type="text"
                                            name="all_number"
                                            defaultValue={res.all_number || ""}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["user.all_number"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.billing_address != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.billing_address" />
                                          </label>

                                          <Input
                                            key={res.billing_address}
                                            type="text"
                                            name="billing_address"
                                            defaultValue={res.billing_address}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.billing_address"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.hescode != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.hescode" />
                                          </label>
                                          <Input
                                            key={res.hescode}
                                            type="text"
                                            name="hescode"
                                            defaultValue={res.hescode}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.hescode"]}
                                            className="w-60 w-xs-100"
                                          />{" "}
                                        </FormGroup>
                                      )}
                                      {res.TM6Form_number != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.TM6Form_number" />
                                          </label>
                                          <Input
                                            key={res.TM6Form_number}
                                            type="text"
                                            name="TM6Form_number"
                                            defaultValue={res.TM6Form_number}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.TM6Form_number"]}
                                            className="w-60 w-xs-100"
                                          />{" "}
                                        </FormGroup>
                                      )}
                                      {res.has_traveled === true || res.has_traveled === false ? (
                                        <FormGroup>
                                          <label className="w-100 w-xs-100">
                                            <Input
                                              key={res.has_traveled}
                                              type="checkbox"
                                              name="has_traveled"
                                              checked={res.has_traveled}
                                              onChange={e => this.handleCheckBox(e, res.id, res, index)}
                                            />{" "}
                                            <IntlMessages id="booking.has_traveled" />
                                          </label>
                                        </FormGroup>
                                      ) : (
                                        ""
                                      )}
                                      {res.loyalty_program != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.loyalty_program" />
                                          </label>

                                          <Input
                                            key={res.loyalty_program}
                                            type="text"
                                            name="loyalty_program"
                                            defaultValue={res.loyalty_program}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.loyalty_program"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.dietary_requirements != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.dietary_requirements" />
                                          </label>

                                          <Input
                                            key={res.dietary_requirements}
                                            type="text"
                                            name="dietary_requirements"
                                            defaultValue={res.dietary_requirements}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.dietary_requirements"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.postal_code != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.postal_code" />
                                          </label>

                                          <Input
                                            key={res.postal_code}
                                            type="text"
                                            name="postal_code"
                                            defaultValue={res.postal_code}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.postal_code"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.arrival_flight != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.arrival_flight" />
                                          </label>

                                          <Input
                                            key={res.arrival_flight}
                                            type="text"
                                            name="arrival_flight"
                                            defaultValue={res.arrival_flight}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.arrival_flight"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.departure_flight != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.departure_flight" />
                                          </label>

                                          <Input
                                            key={res.departure_flight}
                                            type="text"
                                            name="departure_flight"
                                            defaultValue={res.departure_flight}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.departure_flight"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.visa_type != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            <IntlMessages id="booking.visa_type" />
                                          </label>

                                          <Input
                                            key={res.visa_type}
                                            type="text"
                                            name="visa_type"
                                            defaultValue={res.visa_type}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.visa_type"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.visa_expiry_date != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.visa_expiry_date" />
                                          </label>

                                          <Input
                                            key={res.visa_expiry_date}
                                            type="text"
                                            name="visa_expiry_date"
                                            defaultValue={res.visa_expiry_date}
                                            onBlur={e => this.handleTextBox(e, res.id, res, index)}
                                            placeholder={messages["booking.visa_expiry_date"]}
                                            className="w-60 w-xs-100"
                                          />
                                        </FormGroup>
                                      )}
                                      {res.passport_front != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.passport_front" />
                                          </label>

                                          <div className="w-60 w-xs-100 d-inline">
                                            <a href={res.passport_front} target="top">
                                              {this.attachment(res.passport_front)}
                                            </a>
                                          </div>
                                        </FormGroup>
                                      )}
                                      {res.passport_back != null && (
                                        <FormGroup>
                                          <label className="w-40 w-xs-100">
                                            {" "}
                                            <IntlMessages id="booking.passport_back" />
                                          </label>

                                          <div className="w-60 w-xs-100 d-inline">
                                            <a href={res.passport_back} target="top">
                                              {this.attachment(res.passport_back)}
                                            </a>
                                          </div>
                                        </FormGroup>
                                      )}
                                    </Form>
                                  </div>
                                </div>
                              </TabPane>
                            );
                          })}
                        </Tabs>
                      </Card>
                    ) : (
                      ""
                    )}

                    <Card className="question d-flex card-body pt-0" style={{ backgroundColor: "#e9ecef" }}>
                      <div className="d-flex flex-grow-1 min-width-zero">
                        <div className="card-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center">
                          <div className="list-item-heading mb-0 truncate w-80 mb-1 mt-1" />
                        </div>
                      </div>
                      <Label className="list-item-heading mb-2 w-100 text-muted">
                        <IntlMessages id="request.message_title" />
                      </Label>
                      <div className="separator mb-4" />

                      <ul className="list-unstyled mb-4">
                        <li>
                          {commentMessageCards}
                          {emptyStateMessageCard}
                        </li>
                      </ul>
                      <div>
                        <div className="separator mb-2" />
                        {request && request.comments && request.comments.length ? (
                          <div className="float-left">
                            <Button
                              onClick={this.handleCommentsTranslation}
                              type="button"
                              className="btn outline-light flex-grow-1 "
                              color="outline-success"
                              size="xs"
                            >
                              {this.props.requestApp.isTranslationNeeded === false ? (
                                <IntlMessages id="request.message_view_translation" />
                              ) : (
                                <IntlMessages id="request.message_show_original" />
                              )}
                            </Button>
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                      <div
                        className="d-xs-inline-block d-sm-inline-block d-md-none scrollto-top"
                        style={{ display: `${this.state.prevScrollpos < 80 ? "none" : "block"}` }}
                      >
                        {/* <Button color="light" size="xs"> */}
                        <Button onClick={this.scrollToTop} type="button" className="btn outline-light flex-grow-1 " color="light" size="sm">
                          <i className="simple-icon-arrow-up-circle" style={{ fontSize: "17px" }} />{" "}
                          {/* <span><IntlMessages id="request.pageUp" /></span> */}
                        </Button>
                      </div>
                    </Card>
                    <div className="saySomething-for-print">
                      {" "}
                      <SaySomething
                        placeholder={messages["request.chat_say_something"]}
                        messageInput={messageInput}
                        request={request}
                        staffId={this.props.staffId}
                      />
                    </div>
                  </Colxx>
                </Row>
              </Fragment>
            </Colxx>
          </Row>
        </Fragment>
      );
    }
    if (this.state.thirtySecondsPassedAfterDidMount) {
      return (
        <div className="text-center">
          {/* <i className="iconsminds-information text-muted" style={{ fontSize: '25px' }} /> */}
          <div className="list-item-heading mb-2 text-muted" style={{ fontSize: "25px" }}>
            <i className="iconsminds-information text-muted" />
            <IntlMessages id="request.wrong_request_page" />
          </div>
        </div>
      );
    }
    return <div className="loading" />;
  }
}

const mapStateToProps = ({ requestApp, bookingApp, settings, auth }) => {
  const toReturn = { requestApp, settings, bookingApp };
  if (auth && auth.profile && auth.profile.sub) {
    toReturn.staffId = auth.profile.sub;
  }
  return toReturn;
};

export default injectIntl(
  connect(
    mapStateToProps,
    {
      getRequestListDelta,
      addCommentItem,
      createBookingItem,
      addRequestItem,
      requestGetItem,
      setIsTranslationNeeded
    }
  )(FastCheckinDetailsContainer)
);
